import React, { useMemo } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { WRITERS_STATUS } from '../../../../../../constants';

import scss from '../WritersList.module.scss';

const StatusCell = ({ status }) => {
  const { t } = useTranslation('settings');

  const mappedStatusStyles = useMemo(
    () => ({
      [WRITERS_STATUS.ACTIVE]: {
        style: scss.statusCellActive,
        label: t('active'),
      },
      [WRITERS_STATUS.DISABLED]: {
        style: scss.statusCellDisabled,
        label: t('disabled'),
      },
    }),
    [t],
  );

  const selectedStatus = mappedStatusStyles[status];

  return <div className={clsx(scss.statusCell, selectedStatus?.style)}>{selectedStatus.label}</div>;
};

export default StatusCell;
